import React, { createContext, MutableRefObject, useRef } from 'react';
import { MandatoryChildren } from '../models/children-props';

export type ModalRefType = {
  id: string;
};
export type ModalUpdaterPayload = { type: 'add'; value: string } | { type: 'remove'; value: string };
type ModalUpdaterFunction = (payload: ModalUpdaterPayload) => (ref: MutableRefObject<ModalRefType[]>) => void;

export const ModalsContextInitial: MutableRefObject<ModalRefType[]> = { current: [] };

const modalUpdater: ModalUpdaterFunction =
  (payload): ((ref: MutableRefObject<ModalRefType[]>) => void) =>
  (ref): void => {
    const { type, value } = payload;
    switch (type) {
      case 'add': {
        ref.current = [...ref.current, { id: value }];
        break;
      }
      case 'remove': {
        if (ref.current.length) {
          ref.current = ref.current.filter(item => item.id !== value);
        }
        break;
      }
    }
  };

export const ModalsContext = createContext<[MutableRefObject<ModalRefType[]>, ModalUpdaterFunction]>([
  ModalsContextInitial,
  modalUpdater
]);

export const ModalsProvider = ({ children }: MandatoryChildren): JSX.Element => {
  const ref = useRef<ModalRefType[]>([]);
  return <ModalsContext.Provider value={[ref, modalUpdater]}>{children}</ModalsContext.Provider>;
};
